import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { VpnKey as CodeIcon } from "@mui/icons-material";
import { FormEvent } from "react";

interface CodeVerificationProps {
  code: string;
  codeEmail: string;
  loading: boolean;
  onCodeChange: (code: string) => void;
  onSubmit: (e: FormEvent) => void;
  onResendCode: () => void;
  onBackToPassword: () => void;
  formClassName: string;
  switchModeClassName: string;
}

const CodeVerification = ({
  code,
  codeEmail,
  loading,
  onCodeChange,
  onSubmit,
  onResendCode,
  onBackToPassword,
  formClassName,
  switchModeClassName
}: CodeVerificationProps) => {
  return (
    <>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary" align="center">
          Enter the 6-digit code sent to <strong>{codeEmail}</strong>
        </Typography>
      </Box>
      
      <form className={formClassName} onSubmit={onSubmit}>
        <TextField
          label="Verification Code"
          value={code}
          onChange={(e) => onCodeChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
          required
          fullWidth
          variant="outlined"
          placeholder="123456"
          inputProps={{ 
            style: { textAlign: 'center', fontSize: '1.5rem', letterSpacing: '0.5rem' },
            maxLength: 6
          }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading || code.length !== 6}
          startIcon={<CodeIcon />}
          sx={{ mt: 1 }}
        >
          {loading ? (
            <><CircularProgress size={20} sx={{ mr: 1 }} />Verifying...</>
          ) : (
            <>Verify Code</>
          )}
        </Button>
      </form>
      
      <Box textAlign="center" mt={2} display="flex" flexDirection="column" gap={1}>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onResendCode}
        >
          Didn't receive the code? Resend
        </Typography>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onBackToPassword}
        >
          Back to password login
        </Typography>
      </Box>
    </>
  );
};

export default CodeVerification;